import { OnboardingDeprecatedService } from '@/core/services/onboarding-deprecated.service';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'onboarding',
  pure: true,
})
export class OnboardingPipe implements PipeTransform {
  public constructor(private readonly _onboardingService: OnboardingDeprecatedService) { }

  public transform(id: number): Observable<boolean> {
    return this._onboardingService.getFeaturedElements().pipe(
      map((next) => next.map(item => item.id).includes(id, 0)),
    );
  }
}
